export var menuItems = {
  "data": [
    {
      "headTitle1": "General",
      "headTitle2": "Dashboards, Widgets & Layout",
      "type": "headtitle"
    },
    {
      "title": "Dashboard",
      "faIcon": "fa-solid fa-tachometer-alt",
      "type": "sub",
      "badgeType": "light-primary",
      "active": false,
      "path": "/dashboard"
    },
    {
      "title": "Master Data",
      "faIcon": "fa-solid fa-database",
      "type": "sub",
      "badgeType": "light-secondary",
      "active": false,
      "children": [
        {
          "path": "/users",
          "title": "Users",
          "type": "link",
          "active": false
        },
        {
          "path": "/user-roles",
          "title": "User Roles",
          "type": "link",
          "active": false
        },
        {
          "path": "/items",
          "title": "Items",
          "type": "link",
          "active": false
        },
        {
          "path": "/item-price-history",
          "title": "Item Price History",
          "type": "link",
          "active": false
        },
        {
          "path": "/item-price-approve",
          "title": "Approve Item Price",
          "type": "link",
          "active": false
        },

        {
          "path": "/distributor-target",
          "title": "Distributor Targets",
          "type": "link",
          "active": false
        },
        {
          "path": "/lorry-target",
          "title": "Lorry Targets",
          "type": "link",
          "active": false
        },
        {
          "path": "/distributor-target-history",
          "title": "Targets History",
          "type": "link",
          "active": false
        },
        {
          "path": "/distributor-staff",
          "title": "Distributor Staff",
          "type": "link",
          "active": false
        },
        {
          "path": "/distributor-banks",
          "title": "Distributor bank",
          "type": "link",
          "active": false
        },
        {
          "path": "/distributor-vehicles",
          "title": "Distributor Vehicles ",
          "type": "link",
          "active": false
        },
        {
          "path": "/dealers",
          "title": "Dealers",
          "type": "link",
          "active": false
        },
        {
          "path": "/dealer-groups",
          "title": "Dealer Groups",
          "type": "link",
          "active": false
        },
        {
          "path": "/promotions",
          "title": "Promotions",
          "type": "link",
          "active": false
        },
        {
          "path": "/promotion_approval",
          "title": "Promotion Approval",
          "type": "link",
          "active": false
        },
        {
          "path": "/routes",
          "title": "Routes",
          "type": "link",
          "active": false
        },
        {
          "path": "/working-day-calendar",
          "title": "Working Day Calendar",
          "type": "link",
          "active": false
        },
        {
          "path": "/module-route-configurations",
          "title": "Module & Route Config",
          "type": "link",
          "active": false
        },
      ]
    },
    {
      "title": "Orders",
      "faIcon": "fa-solid fa-shopping-cart",
      "type": "sub",
      "badgeType": "light-secondary",
      "active": false,
      "children": [
        {
          "path": "/orders",
          "title": "Order Management",
          "type": "link",
          "active": false
        }
      ]
    },
    {
      "title": "Complaints",
      "faIcon": "fa-solid fa-comments",
      "type": "sub",
      "badgeType": "light-secondary",
      "active": false,
      "children": [
        {
          "path": "/complaints",
          "title": "Complaint Management",
          "type": "link",
          "active": false
        }
      ]
    },
    {
      "title": "Stock",
      "faIcon": "fa-solid fa-boxes",
      "type": "sub",
      "badgeType": "light-secondary",
      "badgeValue": "",
      "active": false,
      "children": [
        {
          "path": "/order-request-history",
          "title": "Order Request",
          "type": "link",
          "active": false
        },
        {
          "path": "/order-request-schedule",
          "title": "Order Request Schedule",
          "type": "link",
          "active": false
        },
        {
          "path": "/grn",
          "title": "GRN",
          "type": "link",
          "active": false
        },
        {
          "path": "/stock-allocation",
          "title": "Stock Allocation",
          "type": "link",
          "active": false
        },
        {
          "path": "/dispatch",
          "title": "Dispatch",
          "type": "link",
          "active": false
        },
        {
          "path": "/gate-pass",
          "title": "Gate Pass [Out]",
          "type": "link",
          "active": false
        },
        {
          "path": "/gate-pass-in",
          "title": "Gate Pass [In]",
          "type": "link",
          "active": false
        },
        {
          "path": "/stock-adjustment",
          "title": "Stock Adjustment",
          "type": "link",
          "active": false
        },
        {
          "path": "/stock-adjustment-approval",
          "title": "Stock Adjustment Approval",
          "type": "link",
          "active": false
        },
        {
          "path": "/stock-adjustment-history",
          "title": "Stock Adjustment History",
          "type": "link",
          "active": false
        },
        {
          "path": "/initial-stock",
          "title": "Initial Stock",
          "type": "link",
          "active": false
        },
        {
          "path": "/delivery-shedule",
          "title": "Delivery Shedule",
          "type": "link",
          "active": false
        },
        {
          "path": "/delivery-schedule",
          "title": "Delivery Schedule",
          "type": "link",
          "active": false
        },
        {
          "path": "/delivery-schedule-history",
          "title": "Delivery Schedule History",
          "type": "link",
          "active": false
        }
      ]
    },
    {
      "title": "Invoice",
      "faIcon": "fa-solid fa-file-invoice-dollar",
      "type": "sub",
      "badgeType": "light-secondary",
      "active": false,
      "children": [
        {
          "path": "/invoice",
          "title": "View Invoice",
          "type": "link",
          "active": false
        },
        {
          "path": "/new-invoice",
          "title": "New Invoice",
          "type": "link",
          "active": false
        },
        {
          "path": "/invoice-summary-report",
          "title": "Invoice Summary",
          "type": "link",
          "active": false
        },
        {
          "path": "/invoice-payment",
          "title": "Invoice Payment",
          "type": "link",
          "active": false
        },
      ]
    },
    {
      "title": "Reports",
      "faIcon": "fa-solid fa-chart-line",
      "type": "sub",
      "badgeType": "light-secondary",
      "active": false,
      "children": [
        {
          "path": "/daily-sales-report",
          "title": "Dealer Sales Update",
          "type": "link",
          "active": false
        },
        {
          "path": "/dealer-visit-report",
          "title": "Dealer Visit Report",
          "type": "link",
          "active": false
        },
        {
          "path": "/distributor-stock-report",
          "title": "Distributor Stock Report",
          "type": "link",
          "active": false
        },
        {
          "path": "/vehicle-stock-report",
          "title": "Vehicle Wise Stock",
          "type": "link",
          "active": false
        },
        {
          "path": "/order-request-schedule-report",
          "title": "Order Request Schedule Report",
          "type": "link",
          "active": false
        },
        {
          "path": "/direct-loss-sale-report",
          "title": "Direct Lost Sale Report",
          "type": "link",
          "active": false
        },
        {
          "path": "/dayend-report",
          "title": "Day End Report",
          "type": "link",
          "active": false
        },
        {
          "path": "/distributor-wise-dealer-sales-report",
          "title": "Distributor wise Dealer Sales Report",
          "type": "link",
          "active": false
        },
        {
          "path": "/distributorsales",
          "title": "Distributor wise Sales Report",
          "type": "link",
          "active": false
        },
        {
          "path": "/asmfsmwisesales",
          "title": "ASM/FSM wise Sales Report",
          "type": "link",
          "active": false
        },
        {
          "path": "/dealerstatementreport",
          "title": "Dealer Statement Report",
          "type": "link",
          "active": false
        },
        {
          "path": "/distributor-wise-dealer-stock-report",
          "title": "Distributor Wise Dealer Stock Report",
          "type": "link",
          "active": false
        },
        {
          "path": "/daily-sales-monitoring-report",
          "title": "Daily Sales Monitoring Report",
          "type": "link",
          "active": false
        },
        {
          "path": "/dealer-vat-report",
          "title": "Dealer VAT Report",
          "type": "link",
          "active": false
        },
        {
          "path": "/stock-return-report",
          "title": "Stock Return Report",
          "type": "link",
          "active": false
        },
        {
          "path": "/cash-balancing-report",
          "title": "Cash Balancing Report",
          "type": "link",
          "active": false
        },
        {
          "path": "/credit-note-report",
          "title": "Credit Note Report",
          "type": "link",
          "active": false
        },
        {
          "path": "/trust_process_report",
          "title": "Trust Process Report",
          "type": "link",
          "active": false
        },
        {
          "path": "/ageing-analysis-report",
          "title": "Ageing Analysis Report",
          "type": "link",
          "active": false
        }
      ]
    }
  ]
}